import { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const defaultLines = [
  { text: "VA HOME LOAN QUALIFICATION", cls: "text-white" },
  { text: "SHOULD NOT FEEL", cls: "text-white/[0.28]" },
  { text: "LIKE DECODING", cls: "text-white" },
  { text: "FINE PRINT.", cls: "text-[var(--accent)]" },
];

const defaultParagraph = "VA entitlement, funding fees, residual income, certificates of eligibility — for most VA-eligible buyers in FL, TX & PA, qualifying feels like reading a contract written for someone else. So you fill out generic online forms, wait on slow lenders, and still don't know your real number. In 45 minutes, this live review replaces the guesswork with your exact position — in plain English.";

export const Manifesto = ({
  label = "[001] — THE PROBLEM",
  lines = defaultLines,
  paragraph = defaultParagraph,
  ctaLabel = "✓ RESERVE MY FREE SEAT",
  ctaTarget = "register",
}) => {
  const ref = useRef(null);
  useEffect(() => {
    const words = ref.current.querySelectorAll(".m-word");
    gsap.fromTo(words, { opacity: 0, y: 24 }, {
      opacity: 1, y: 0, duration: 0.6, stagger: 0.04, ease: "power2.out",
      scrollTrigger: { trigger: ref.current, start: "top 72%" },
    });
  }, []);

  return (
    <section ref={ref} className="py-32 px-6 lg:px-12" data-testid="manifesto-section">
      <div className="max-w-[1440px] mx-auto grid lg:grid-cols-[1fr_auto] gap-16 items-center">
        <div>
          <p className="mono text-[11px] tracking-[0.25em] text-[var(--accent)] mb-8">{label}</p>
          <h2 className="h1-display text-[clamp(36px,5vw,68px)] leading-[0.97] max-w-[900px]">
            {lines.map((l, li) => (
              <span key={li} className={`block ${l.cls}`}>
                {l.text.split(" ").map((w, wi) => (
                  <span key={wi} className="m-word inline-block mr-[0.28em]">{w}</span>
                ))}
              </span>
            ))}
          </h2>
          <p className="text-[16px] text-white/55 leading-[1.75] max-w-[560px] mt-10">{paragraph}</p>
          <button className="btn-outline cta mt-10" data-testid="manifesto-cta"
            onClick={() => document.getElementById(ctaTarget)?.scrollIntoView({ behavior: "smooth" })}>
            {ctaLabel}
          </button>
        </div>
        <div className="pixel-cluster w-[220px] hidden lg:grid">
          {Array.from({ length: 64 }).map((_, i) => <span key={i} />)}
        </div>
      </div>
    </section>
  );
};
